import SoftBadge from 'components/common/SoftBadge';
import React, { Fragment } from 'react';
import PropTypes from 'prop-types';

const HrAdminBadge = (props) => {
  const {value} = props

  const hr_admins = value && value.map((name, index) => (
    <SoftBadge bg='info' key={index} className='tw-mr-2'>{name}</SoftBadge>
  ))

  return (
    <Fragment>
      {hr_admins}
    </Fragment>
  );
};

HrAdminBadge.propTypes = {
  value: PropTypes.arrayOf(PropTypes.string).isRequired,
};

export default HrAdminBadge;
